export enum AddDaysType {
    Standard = 1,
    BonusDay = 2
}
